import React from "react";
import './Indicator.css';
import {Spin} from "antd";
import { LoadingOutlined } from '@ant-design/icons';

export default function Indicator(){
    return (
        <div className="loading-spinner_backdrop">
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
                <Spin
                    tip="Loading"
                    size="large"
                    style={{ color: "#f13434 " }}
                    indicator={<LoadingOutlined/>}/>
            </div>
        </div>
    );
}